import React from 'react';
import { Button, Table, Loader, Grid, Form, Icon, Popup, Segment, Checkbox, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { fetchCurrentAcademicYear, fetchGroupTypes } from '../../Lookups/util';

import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema kreiranih grupa.</p>;

export default class StudentGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            newName: null,

            currentAcademicYear: null,

            courseBasics: [],
            groupType: '',
            courseImplementations: [],
            courseBasic: '',
            courseImplementation: '',
            academicYears: [],
            academicYearId: '',
            showGroups: false,

            copyWithStudents: false,
            copiedError: false,
            loading: false,
            showCopyForm: false,
            deletingGroup: false,

            confirmArchiveGroupId: null,

        };
        this.deleteGroup = this.deleteGroup.bind(this);
        this.editName = this.editName.bind(this);

        this.getImplementations = this.getImplementations.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    deleteGroup(id) {
        let obj = {};
        this.setState({
            deletingGroup: true,
        });
        axios.delete(`course/groups/delete/${id}`)
            .then(res => {
                this.setState({
                    deletingGroup: false,
                });
                toast('Brisanje grupe je uspješno izvršeno.');
                this.props.getGroups(localStorage.getItem('groupType'), localStorage.getItem('courseImplementation'));
            })
            .catch(err => {
                this.setState({
                    deletingGroup: false,
                });
                let message = null;
                if (err && err.response && err.response.data) {
                    message = err.response.data;
                }

                if (message === 'Students are added to this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoje upisani studenti.');
                } else if (message === 'Exams are created for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoji kreiran ispit.');
                } else if (message === 'Staff is added to this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoji dodano osoblje.');
                } else if (message === 'There are questionnaire answers from students for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer je povezana sa anketama i postoje odgovori studentata.');
                } else if (message === 'Questionnaire statistics is created for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer je kreirana statistika za anketu.');
                } else if (message === 'Staff questionnaire structure is created for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoji kreiran izvještaj strukture uzoraka.');
                } else {
                    toast('Došlo je do greške! Brisanje grupe nije uspješno izvršeno!');
                }
            });
    }


    editName(id, optLock) {
        let obj = {
            id, optLock, name: this.state.newName
        };
        axios.put('course/groups/update', { ...obj })
            .then(res => {
                toast('Izmjena naziva grupe je uspješno izvršena.');
                this.setState({ editMode: false });
                this.props.getGroups(localStorage.getItem('groupType'), localStorage.getItem('courseImplementation'));
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena naziva grupe nije izvršena!');
            });
    }

    getImplementations(courseBasic, academicYearId) {
        axios.get(`course/implementations/by-course-basic-and-academic-year/${courseBasic}/${academicYearId}/`)
            .then(res => {
                const courseImplementations = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.comment ? el.semesters[0].name.name + ' ' + el.semesters[0].academicYear.name + ' - ' + el.comment : el.semesters[0].name.name + ' ' + el.semesters[0].academicYear.name
                })).sort((a, b) => b.semesters[0].academicYear.startYear - a.semesters[0].academicYear.startYear);
                this.setState({ courseImplementations });
            })
            .catch(err => {
                console.log('Failed to fetch course basics');
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'copyCourseBasic') {
            this.getImplementations(parseInt(value, 10), this.state.academicYearId);
            this.setState({ groups: [], showGroups: false, courseImplementation: '' });
            window.localStorage.removeItem('copyCourseImplementation');
            localStorage.setItem('copyCourseBasic', value);
        }
        this.setState({
            [name]: value
        });

        if (name === 'copyCourseImplementation') {
            this.setState({ groups: [], showGroups: false });
            localStorage.setItem('copyCourseImplementation', value);
        }
    }

    componentDidMount() {
        fetchCurrentAcademicYear().then(res => {
            const {
                courseBasics,
                courseBasic,
                groupType,
                courseImplementations,
                courseImplementation
            } = this.props.state;

            if (!groupType) {
                fetchGroupTypes().then(res => {
                    this.setState({
                        groupType: res.data.find(e => e._key === 'exam').id,
                    });
                });
            } else {
                this.setState({
                    groupType
                });
            }
            this.setState({
                academicYearId: res.data.id,
                academicYear: res.data,
                courseBasics
            });
            /* this.setState({
                academicYearId: res.data.id,
                academicYear: res.data,
                courseBasics,
                courseBasic,
                courseImplementations,
                courseImplementation
            }); */
        });
    }

    copyGroups() {
        this.setState({ loading: true });
        const sourceImplId = parseInt(localStorage.getItem('courseImplementation'), 10);
        const targetImplId = parseInt(localStorage.getItem('copyCourseImplementation'), 10);
        const groupTypeId = parseInt(localStorage.getItem('groupType'), 10);
        const copyStaff = this.state.copyWithStaff;
        const copyStudents = this.state.copyWithStudents;
        axios.post('/course/groups/copy-groups', null, {
            params: {
                sourceImplId,
                targetImplId,
                groupTypeId,
                copyStudents,
                copyStaff,
            }
        })
            .then(res => {
                this.setState({ showCopyForm: false });
            })
            .catch(err => {
                this.setState({ copiedError: true });
            })
            .finally(() => {
                const wasError = this.state.copiedError;
                this.setState({
                    loading: false,
                    copiedError: false
                }, () => {
                    toast(wasError ? 'Greška prilikom kopiranja.' : 'Grupe su uspješno kopirane.');
                });
            });
    }

    render() {
        if (!this.props.data) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return this.state.loading ?
            (<div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>) :
            (
                <div>
                    {this.state.showCopyForm ?
                        <Segment secondary>
                            <Form>
                                <Form.Group>
                                    <Form.Field disabled={!this.state.academicYearId} width="8">
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odaberite predmet"
                                            value={localStorage.getItem('copyCourseBasic') ? localStorage.getItem('copyCourseBasic') : this.state.courseBasic}
                                            onChange={this.handleInputChange}
                                            name="copyCourseBasic"
                                            options={this.state.courseBasics}
                                            label="Predmet u koji se kopiraju prikazane grupe"
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field disabled={!localStorage.getItem('copyCourseBasic')} width="8">
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odaberite implementaciju predmeta"
                                            value={localStorage.getItem('copyCourseImplementation') ? parseInt(localStorage.getItem('copyCourseImplementation'), 10) : this.state.courseImplementation}
                                            onChange={this.handleInputChange}
                                            name="copyCourseImplementation"
                                            options={this.state.courseImplementations}
                                            label="Implementacija predmeta"
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>&nbsp;</label>
                                        <Button
                                            color="blue"
                                            floated="right"
                                            disabled={!localStorage.getItem('copyCourseImplementation')}
                                            onClick={() => this.copyGroups()}
                                        >
                                            Kopiraj
                                        </Button>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>&nbsp;</label>
                                        <Button
                                            color="blue"
                                            floated="right"
                                            basic="true"
                                            onClick={() => this.setState({ showCopyForm: false })}
                                        >
                                            Odustani
                                        </Button>
                                    </Form.Field>
                                </Form.Group>
                                <Checkbox
                                    label="Kopiraj studente"
                                    defaultChecked={false}
                                    type="checkbox"
                                    name="copyWithStudents"
                                    checked={this.state.copyWithStudents}
                                    onChange={(e, { checked }) => this.setState({ copyWithStudents: checked })}
                                />
                                <br />
                                <Checkbox
                                    label="Kopiraj nastavno osoblje"
                                    defaultChecked={false}
                                    type="checkbox"
                                    name="copyWithStaff"
                                    checked={this.state.copyWithStaff}
                                    onChange={(e, { checked }) => this.setState({ copyWithStaff: checked })}
                                />
                                <br />
                            </Form>
                        </Segment> : ''
                    }

                    {localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId') &&
                    <div></div>}
                    {this.props.loader || this.state.deletingGroup ?
                        <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                        this.props.data.length ?
                            <div>
                                <Message>

                                    Za lakše kreiranje grupa možete koristiti opciju kopiranja prethodnih grupa.
                                    Nakon odabira neke prethodne akademske godine, predmeta i semestra, u prikazanoj tabeli ispod, u gornjem desnom uglu nalazi se dugme <b>"Kopiraj grupe"</b> <Icon name="copy" color="blue" circular/>.
                                    <br />
                                    Osnovna opcija omogućava kopiranje samo naziva grupa, bez studenata i nastavnog osoblja.
                                    Ukoliko dodatno označite opcije „Kopiraj studente“ i/ili „Kopiraj nastavno osoblje“, sistem će izvršiti i kopiranje:
                                    <ul>
                                        <li>
                                            studenata koji su ranije bili u odabranoj grupi, a trenutno su upisani na predmet u koji se vrši kopiranje,
                                        </li>
                                        <li>
                                            nastavnog osoblja, ukoliko je isto već dodano na predmet u koji se kopiraju grupe iz prethodnih akademskih godina ili semestara.
                                        </li>
                                    </ul>

                                </Message>
                                <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan="2">
                                                Naziv grupe
                                            </Table.HeaderCell>
                                            <Table.HeaderCell
                                                textAlign="center"
                                            >
                                                <Popup
                                                    trigger={
                                                        <Button
                                                            icon="copy"
                                                            size="small"
                                                            basic
                                                            color="blue"
                                                            circular
                                                            onClick={() => {
                                                                this.setState({ showCopyForm: !this.state.showCopyForm });
                                                                localStorage.removeItem('copyCourseBasic');
                                                                localStorage.removeItem('copyCourseImplementation');
                                                            }
                                                            }
                                                        />
                                                    }
                                                    content="Kopiraj grupe"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {this.props.data.map((el, index) =>
                                        (<Table.Row key={el.id}>
                                            <Table.Cell verticalAlign="middle" colSpan="2">

                                                <Grid>
                                                    <Grid.Column width={12} verticalAlign="middle">
                                                        {this.state.editMode === index ?
                                                            <Form>
                                                                <Form.Field>
                                                                    <input
                                                                        value={this.state.newName}
                                                                        onChange={(e) => this.setState({ newName: e.target.value })}
                                                                        name="input"
                                                                    />
                                                                </Form.Field>
                                                            </Form>
                                                            : el.name
                                                        }
                                                    </Grid.Column>
                                                    <Grid.Column width={4} textAlign="center">
                                                        {this.state.editMode === index && <div><Popup
                                                            content="Sačuvaj"
                                                            position="top center"
                                                            trigger={<Button
                                                                basic="true"
                                                                circular
                                                                icon="check"
                                                                size="small"
                                                                color="blue"
                                                                onClick={() => this.editName(el.id, el.optLock)}
                                                            ></Button>}
                                                        /><Popup
                                                            content="Odustani"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    basic="true"
                                                                    circular
                                                                    icon="delete"
                                                                    size="small"
                                                                    color="red"
                                                                    onClick={() => this.setState({ editMode: false })}
                                                                >
                                                                </Button>}
                                                        /></div>
                                                        }
                                                    </Grid.Column>
                                                </Grid>


                                            </Table.Cell>
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content="Spisak studenata"
                                                    position="top center"
                                                    trigger={
                                                        <Link to={{
                                                            pathname: !this.props.examGroups ? '/studentske-grupe/studenti' : '/ispitne-grupe/studenti',
                                                            state: {
                                                                courseImplementationGroupId: el.id,
                                                                active: this.props.active,
                                                                groupName: el.name
                                                            }
                                                        }}
                                                        >
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                icon="group"
                                                                size="small"
                                                                color="blue"
                                                            />
                                                        </Link>}
                                                />
                                                <Popup
                                                    content="Nastavno osoblje"
                                                    position="top center"
                                                    trigger={
                                                        <Link to={{
                                                            pathname: !this.props.examGroups ? '/studentske-grupe/nastavno-osoblje' : '/ispitne-grupe/nastavno-osoblje',
                                                            state: {
                                                                courseImplementationGroupId: el.id,
                                                                active: this.props.active,
                                                                groupName: el.name
                                                            }
                                                        }}
                                                        >
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                icon="user"
                                                                size="small"
                                                                color="teal"
                                                            />
                                                        </Link>}
                                                />

                                                {this.props.active && localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId') &&
                                                <Popup
                                                    content="Izmjena"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            color="green"
                                                            circular
                                                            icon="pencil alternative"
                                                            size="small"
                                                            onClick={() => this.setState({
                                                                editMode: index,
                                                                newName: el.name
                                                            })}
                                                        />
                                                    }
                                                />}

                                                {this.props.active && <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={<Button
                                                        color="red"
                                                        basic="true"
                                                        circular
                                                        icon="trash"
                                                        size="small"
                                                        onClick={() => this.setState({ confirmArchiveGroupId: el.id })}
                                                    ></Button>}
                                                />}
                                                {this.state.confirmArchiveGroupId === el.id && (

                                                    <div style={{ marginTop: '10px' }}>
                                                        <h5>Jeste li sigurni da želite obrisati ovu grupu?</h5>
                                                        <Button.Group size="small">
                                                            <Button
                                                                basic
                                                                color="red"
                                                                onClick={() => {
                                                                    this.deleteGroup(el.id);
                                                                    this.setState({ confirmArchiveGroupId: null });
                                                                }}
                                                            >
                                                                DA
                                                            </Button>
                                                            <Button
                                                                basic
                                                                color="blue"
                                                                onClick={() => this.setState({ confirmArchiveGroupId: null })}
                                                            >
                                                                NE
                                                            </Button>
                                                        </Button.Group>
                                                    </div>
                                                )}

                                            </Table.Cell>
                                        </Table.Row>))}
                                    </Table.Body>
                                </Table>
                            </div>
                            : <div><br /><br /><NoDataMessage /></div>

                    }
                    <ToastContainer hideProgressBar />

                </div>

            );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/StudentGroups.js